
import React, { useState, useEffect } from 'react';
import "./style.css"
import { FaSortAlphaDown} from 'react-icons/fa';
import { FaIndianRupeeSign } from 'react-icons/fa6';
import { FaSortNumericDownAlt } from "react-icons/fa";
import { FiInfo } from "react-icons/fi";
import { Tooltip } from "primereact/tooltip";
import { Button, Modal, Table, Tooltip as ToolDisplay } from "antd";
import moment from 'moment';
import { Select } from 'antd';
import Carousel from 'react-multi-carousel';
import { FaFileExcel } from "react-icons/fa6";
import * as XLSX from "xlsx";
import { displayAmount, numberWithCommas } from '../../services/util/util';


export default function ListItemCard({portfolioAllocationData, setPortfolioAllocationData, weightAllocationType, setWeightAllocationType, sectorWeights,selectedAmount, setSelectedAmount}:any) {
    const [bool, setBool] = useState<boolean>(false)
    const [displyPriceDropdown, setDisplayPriceDropdown] = useState<boolean>(false)
    const [leftOverAmount, setLeftOverAmount] = useState<any>(0)
    const [activeButton, setActiveButton] = useState<any>('equal_weights')
    const [manualInput, setManualInput] = useState<string>('');
    const [showModalAllocation, setShowModalAllocation] = useState<boolean>(false);
    const [weightAllocationExcelData, setWeightAllocationExcelData] = useState<any>([]);
    const [deployedAmount, setDeployedAmount] = useState<any>(0)
    const debounceDelay = 500; // Adjust debounce time in milliseconds
    const [fdAmount, setFDAmount] = useState<any>(0)

    useEffect(() => {
        allocationAmount()
    }, [portfolioAllocationData, selectedAmount])


    const allocationAmount = () => {
        let noOfShares:any = 0;
        let noOfShares_eq:any = 0;
        let amountSpent:any = 0;
        let remainingAmount:any = 0;
        let allotedAmount:any = 0;
        let totalRemainingAmount:any = 0;
        let fd_amount:any = 0

        let invRs:any = 0;
        let actualInvRs:any = 0;
        let allotedAmount_OpenTrade:any = 0;
        let totalInvestmentOpenTrades:any = 0;

        let value:any = 0

        let eq_weight = (1/portfolioAllocationData?.length)
        portfolioAllocationData?.map((item:any) => {

            if(item['s_symbol'] != 'FREE'){

                if(Number(item['n_allocation']) >0){
                    
                    allotedAmount = (Number(selectedAmount['value'])*Number(item['n_allocation']))
                    console.log("Check :", selectedAmount['value'], "----", item['n_allocation'], " allotedAmount : ", allotedAmount, "symbol : ", item?.s_symbol, "--- Value : ", value)
                    noOfShares  = Math.floor((Number(selectedAmount['value'])*Number(item['n_allocation'])) / Number(item['n_open']))
                    amountSpent = noOfShares * Number(item['n_open'])
                    remainingAmount = allotedAmount - amountSpent
    
                    if(item['open'] == true) {
    
                        allotedAmount_OpenTrade = (Number(selectedAmount['value'])*Number(item['n_allocation']))
    
                        invRs = Number(allotedAmount_OpenTrade / noOfShares)
                        
                        actualInvRs = Number(item['n_open']) * Number(noOfShares)
    
                        totalInvestmentOpenTrades = totalInvestmentOpenTrades + actualInvRs
                    }
                }
                else{
                    noOfShares = 0
                }
                noOfShares_eq = Math.floor((Number(selectedAmount['value'])*Number(eq_weight)) / Number(item['n_open']))
    
                item['allotedAmount']   = allotedAmount
                item['noOfShares']      = noOfShares
                item['amountSpent']     = amountSpent
                item['remainingAmount'] = remainingAmount
                item['noOfShares_eq']   = noOfShares_eq
    
                totalRemainingAmount = totalRemainingAmount+remainingAmount
            }
            else{
                fd_amount = Number(selectedAmount['value']) * item['n_allocation']
            }

        })


        console.log("FREE AMOUNT : ",fd_amount)

        if (bool === false){
            setFDAmount(fd_amount)
            setLeftOverAmount(totalRemainingAmount)
            setDeployedAmount(totalInvestmentOpenTrades)
        }
    }


    let obj:any = {'ADANIPORTS' : 'Adani Ports and Special Economic Zone Ltd.',
        'APOLLOHOSP' : 'Apollo Hospitals Enterprise Ltd.',
        'ASIANPAINT' : 'Asian Paints Ltd.',
        'AXISBANK' : 'Axis Bank Ltd.',
        'BAJAJFINSV' : 'Bajaj Finserv Ltd.',
        'BHARTIARTL' : 'Bharti Airtel Ltd.',
        'BRITANNIA' : 'Britannia Industries Ltd.',
        'COALINDIA' : 'Coal India Ltd.',
        'DRREDDY' : "Dr. Reddy's Laboratories Ltd.",
        'GRASIM' : 'Grasim Industries Ltd.',
        'HCLTECH' : 'HCL Technologies Ltd.',
        'HDFCBANK' : 'HDFC Bank Ltd.',
        'HEROMOTOCO' : 'Hero MotoCorp Ltd.',
        'HINDALCO' : 'Hindalco Industries Ltd.',
        'HINDUNILVR' : 'Hindustan Unilever Ltd.',
        'ICICIBANK' : 'ICICI Bank Ltd.',
        'INDUSINDBK' : 'IndusInd Bank Ltd.',
        'INFY' : 'Infosys Ltd.',
        'ITC' : 'ITC Ltd.',
        'JSWSTEEL' : 'JSW Steel Ltd.',
        'LT' : 'Larsen & Toubro Ltd.',
        'MARUTI' : 'Maruti Suzuki India Ltd.',
        'M&M' : 'Mahindra & Mahindra Financial Services Ltd.',
        'NESTLEIND' : 'Nestle India Ltd.',
        'NTPC' : 'NTPC Ltd.',
        'ONGC' : 'Oil & Natural Gas Corporation Ltd.',
        'POWERGRID' : 'Power Grid Corporation of India Ltd.',
        'RELIANCE' : 'Reliance Industries Ltd.',
        'SBIN' : 'State Bank of India',
        'SUNPHARMA' : 'Sun Pharmaceutical Industries Ltd.',
        'TATAMOTORS' : 'Tata Motors Ltd.',
        'TITAN' : 'Titan Company Ltd.',
        'ULTRACEMCO' : 'UltraTech Cement Ltd.'}

    useEffect(() => {
        var val:any
        if (bool === true){
            if(activeButton === 'equal_weights'){
                val = [...portfolioAllocationData].sort((a:any, b:any) => b.n_allocation - a.n_allocation);
            }else{
                val = [...sectorWeights].sort((a:any, b:any) => b.y - a.y);
            }

        }
        else{
            if(activeButton === 'equal_weights'){
            val = [...portfolioAllocationData].sort((a:any, b:any) => (a.s_symbol).localeCompare(b.s_symbol));
            }else{
                val = [...sectorWeights].sort((a:any, b:any) => b.y - a.y);
            }
        }

        setPortfolioAllocationData(val);
    }, [bool, activeButton])

    useEffect(()=>{
        let arr:any = []
        portfolioAllocationData?.map((item:any)=>{
            arr?.push({"s_symbol":item?.s_symbol, 'eq_weight':((1 / portfolioAllocationData?.length) * 100)?.toFixed(2),'eq_weights_shares': item?.noOfShares_eq , 'fs_weight': Number((Number(item.n_allocation) * 100)?.toFixed(2)),'fs_weights_shares': item?.noOfShares})        })
        if(arr){
            setWeightAllocationExcelData(arr || [])
        }
    },[portfolioAllocationData, selectedAmount])

    const sortAccordingName = () => {
        setBool(!bool)
    }

    const handleChange = (value: number) => {
        const selectedObj = displayAmount.find((item:any) => item.value === value);
        setSelectedAmount(selectedObj || displayAmount[0]); // Fallback to first item
    };



    const handleCustomChange = (value: string) => {
        setManualInput(value); // Update the temporary input state
    };

    // Debounce effect to update selectedAmount after typing stops
    useEffect(() => {
        const handler = setTimeout(() => {
            const numericValue = parseFloat(manualInput.replace(/[^0-9]/g, '')); // Extract numbers
            if (!isNaN(numericValue)) {
                setSelectedAmount({ name: `${numericValue}`, value: numericValue });
            }
        }, debounceDelay);

        return () => clearTimeout(handler); // Cleanup on re-renders
    }, [manualInput]);

    const responsive = {
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 8,partialVisibilityGutter: 20,},
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
      };

    const downloadMutualExcel = (data: any) => {
    if (!data || data.length === 0) {
        console.error("No data available to export.");
        return;
    }
    // Define column headers
    const headers = [["Company Name", 'Equal Weight(%)', 'Equal Shares Qty','Portfolio Weight(%)', 'Portfolio Shares Qty']];

    // Summary rows (Added immediately after headers)


    // Convert mutual fund data to an array of arrays
    const formattedData = data.map((item: any) => [item.s_symbol, item.eq_weight, item.eq_weights_shares, item.fs_weight, item.fs_weights_shares]);
    const finalData = [...headers, ...formattedData];
    // Combine headers, summary rows, and mutual fund data

    console.log("Final Data :",finalData)

    // Create a new worksheet using aoa_to_sheet (Array of Arrays)
    const worksheet = XLSX.utils.aoa_to_sheet(finalData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the file
    XLSX.writeFile(workbook, "Weight Allocation.xlsx");
    
    };

    const columnsWT = [
        {
            title: 'Company Name',
            dataIndex: 's_symbol',
            key: 's_symbol',
            width: "60%", // Adjust width for spacing
            sorter: (a: any, b: any) => a['s_symbol']?.toString()?.localeCompare(b['s_symbol']),
            // align: "center" as "center",
        },
        {
            title: 'Equal Weight(%)',
            dataIndex: 'eq_weight',
            key: 'eq_weight',
            width: "40%", // Adjust width for spacing
            align: "center" as "center",
            sorter: (a: any, b: any) => a['eq_weight'] - b['eq_weight'],
            render: (val: any) => <b style={{ color: val >= 0 ? 'green' : 'red' }}>{val}</b>,
        },
        {
            title: 'Equal Shares Qty',
            dataIndex: 'eq_weights_shares',
            key: 'eq_weights_shares',
            width: "40%", // Adjust width for spacing
            align: "center" as "center",
            sorter: (a: any, b: any) => a['eq_weights_shares'] - b['eq_weights_shares'],
        },
        {
            title: 'Portfolio Weight(%)',
            dataIndex: 'fs_weight',
            key: 'fs_weight',
            width: "40%", // Adjust width for spacing
            align: "center" as "center",
            sorter: (a: any, b: any) => a['fs_weight'] - b['fs_weight'],
            render: (val: any) => <b style={{ color: val >= 0 ? 'green' : 'red' }}>{val}</b>,
        },
        {
            title: 'Portfolio Shares Qty',
            dataIndex: 'fs_weights_shares',
            key: 'fs_weights_shares',
            width: "40%", // Adjust width for spacing
            align: "center" as "center",
            sorter: (a: any, b: any) => a['fs_weights_shares'] - b['fs_weights_shares'],
        },
    ];

    return (
        <>
            <div className='portfolioAllocationListCard'>
                <Tooltip className='tooltip_portfolio'  target=".ModelWeightsInfo" content={`Last updated on: ${moment(portfolioAllocationData[0]?.dt_date).format("DD MMM YYYY")}`}   />
                <div className='portfolioAllocationCardHeader'>
                    <p className='modelWeightsHeading'>Weight Allocation
                            <span>&nbsp;<FiInfo className='ModelWeightsInfo'/></span>
                    </p>
                    <div style={{ margin: "0.5rem", display:'flex', alignItems:'center'}}>
                        <span style={{ display: 'flex', justifyContent: 'end', color: '#2ca32c', fontSize: '1.3rem', cursor: 'pointer',padding: '5px 8px' }}><FaFileExcel onClick={()=>setShowModalAllocation(true)}/></span>
                        <span  className='sortIconPortfolio sortHover' style={{color:'blue'}} onClick={sortAccordingName}>{bool=== false ?<ToolDisplay title='Sort Numerically'><FaSortNumericDownAlt /></ToolDisplay>: <ToolDisplay title='Sort Alphabetically'><FaSortAlphaDown /></ToolDisplay>}</span>

                        <div className='portfolioDropdown'>
                             <Select
                                style={{ width: 120, borderRadius: '5px' }}
                                value={selectedAmount.value} 
                                onChange={handleChange}
                                showSearch // Allows manual input
                                filterOption={true} // Disables default filtering
                                onSearch={handleCustomChange} // Captures user input
                            >
                                {displayAmount.map((item:any) => (
                                    <Select.Option key={item.value} value={item.value}>
                                        {item.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>
                        <span  className='sortIconPortfolio' onClick={() => {setDisplayPriceDropdown(!displyPriceDropdown)}}></span>
                        <div className='amountDiv'>
                            <div className="section1" style={{marginRight:'0.5rem'}}>
                                <p className='amountCardP'>Allocated : <span className='amoutSpan'>{numberWithCommas(selectedAmount['value'])}</span></p>
                                <p className='amountCardP'>Deployed : <span className='amoutSpan'>{numberWithCommas(Number(deployedAmount)?.toFixed(2))}<span style={{fontWeight:'400'}}>({((deployedAmount/selectedAmount['value'])*100)?.toFixed(2)}%)</span></span></p>
                            </div>  
                            <div className="section2">
                                <p className='amountCardP'>Blocked : <span className='amoutSpan'>{numberWithCommas(Number(selectedAmount['value'] - (Number(deployedAmount) + Number(fdAmount)))?.toFixed(2))}<span style={{fontWeight:'400'}}>({(((selectedAmount['value'] - (Number(deployedAmount) + Number(fdAmount))) / selectedAmount['value'])*100)?.toFixed(2)}%)</span></span></p>
                                <p className='amountCardP'>Freehold : <span className='amoutSpan'>{numberWithCommas(Number(fdAmount))}<span style={{fontWeight:'400'}}>({Number(fdAmount / (selectedAmount['value']) * 100)?.toFixed(2)}%)</span></span></p>
                            </div>
                        </div>
                    </div>
                </div>
                <Carousel responsive={responsive} infinite={false} autoPlay={false} keyBoardControl={true} slidesToSlide={3} >
                    {portfolioAllocationData?.map((item: any) => (
                    item.s_symbol!= 'FREE' && <div className="pListItem" key={item.s_symbol}>
                        <div className="symbolAndCompSection">
                        <img className="stockImg" src={`/svgImage/${item.s_symbol}.svg`} alt="" />
                        <span className="symbolName">{item.s_symbol} <span className="priceSpan">₹{item?.n_open}</span></span>
                        </div>
                        <div className="list_item_sub_card_master_cls">
                        <div className="list_item_sub_card_ew">
                            <p className="sub_item_header">Equal Weights</p>
                            <p className="list_item_sub_card_oth_prop">Allocation: <span style={{ fontWeight: "bold" }}>{((1 / portfolioAllocationData?.length) * 100)?.toFixed(2)}%</span></p>
                            <p className="list_item_sub_card_oth_prop">Qty: <span style={{ fontWeight: "bold" }}>{item?.noOfShares_eq}</span></p>
                        </div>
                        <div className="list_item_sub_card_fs">
                            <p className="sub_item_header">FS Weights {item['open'] && <span className="live_icon"></span>}</p>
                            <p className="list_item_sub_card_oth_prop">Allocation: <span style={{ fontWeight: "bold" }}>{((item.n_allocation) * 100)?.toFixed(2)}%</span></p>
                            <p className="list_item_sub_card_oth_prop">Qty: <span style={{ fontWeight: "bold" }}>{item?.noOfShares}</span></p>
                        </div>
                        </div>
                    </div>
                    ))}
                </Carousel>
            </div>
            <Modal
                style={{minWidth:'950px'}}
                className="mutualFundModal"
                title={<h5>Weight Allocation Table For {selectedAmount?.name}</h5>}
                centered
                footer={
                <Button onClick={() => downloadMutualExcel(weightAllocationExcelData)} style={{borderRadius:'5px',background:'#c3e0f9'}}>Download</Button>
                }
                // loading = {loading}
                open = {showModalAllocation}
                onCancel={()=>setShowModalAllocation(false)}
            >
            <Table 
                dataSource={weightAllocationExcelData} 
                columns={columnsWT} 
                // bordered
                pagination={false}
                scroll={{ y: 200 }}
                size="middle"
                className="custom-scrollbar"
                // scroll={{  y: 47 * 5 }}
                />

            </Modal>
        </>
    )
}